// AUTO-GENERATED by scratchpad/gen-hidden-words.js — do not edit by hand.
// Source: hidden-words-153.json (verbatim text) + hidden-words-curated.json (answers).
// Sacred text: the `text` field is VERBATIM and must never be edited.

export type HiddenWord = {
  id: string
  collection: 'arabic' | 'persian'
  number: number
  word: string
  text: string
  link: string
}

export const HIDDEN_WORDS: HiddenWord[] = [
  {
    id: "arabic-1",
    collection: "arabic",
    number: 1,
    word: "heart",
    text: "O Son of Spirit! My first counsel is this: Possess a pure, kindly and radiant heart, that thine may be a sovereignty ancient, imperishable and everlasting.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#986635113",
  },
  {
    id: "arabic-2",
    collection: "arabic",
    number: 2,
    word: "sight",
    text: "O Son of Spirit! The best beloved of all things in My sight is Justice; turn not away therefrom if thou desirest Me, and neglect it not that I may confide in thee. By its aid thou shalt see with thine own eyes and not through the eyes of others, and shalt know of thine own knowledge and not through the knowledge of thy neighbor. Ponder this in thy heart; how it behooveth thee to be. Verily justice is My gift to thee and the sign of My loving-kindness. Set it then before thine eyes.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#099947277",
  },
  {
    id: "arabic-3",
    collection: "arabic",
    number: 3,
    word: "image",
    text: "O Son of Man! Veiled in My immemorial being and in the ancient eternity of My essence, I knew My love for thee; therefore I created thee, have engraved on thee Mine image and revealed to thee My beauty.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#246296008",
  },
  {
    id: "arabic-4",
    collection: "arabic",
    number: 4,
    word: "loved",
    text: "O Son of Man! I loved thy creation, hence I created thee. Wherefore, do thou love Me, that I may name thy name and fill thy soul with the spirit of life.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#486363123",
  },
  {
    id: "arabic-5",
    collection: "arabic",
    number: 5,
    word: "reach",
    text: "O Son of Being! Love Me, that I may love thee. If thou lovest Me not, My love can in no wise reach thee. Know this, O servant.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#590841570",
  },
  {
    id: "arabic-6",
    collection: "arabic",
    number: 6,
    word: "enter",
    text: "O Son of Being! Thy Paradise is My love; thy heavenly home, reunion with Me. Enter therein and tarry not. This is that which hath been destined for thee in Our kingdom above and Our exalted dominion.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#312164372",
  },
  {
    id: "arabic-7",
    collection: "arabic",
    number: 7,
    word: "thine",
    text: "O Son of Man! If thou lovest Me, turn away from thyself; and if thou seekest My pleasure, regard not thine own; that thou mayest die in Me and I may eternally live in thee.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#118657418",
  },
  {
    id: "arabic-8",
    collection: "arabic",
    number: 8,
    word: "peace",
    text: "O Son of Spirit! There is no peace for thee save by renouncing thyself and turning unto Me; for it behooveth thee to glory in My name, not in thine own; to put thy trust in Me and not in thyself, since I desire to be loved alone and above all that is.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#102524683",
  },
  {
    id: "arabic-9",
    collection: "arabic",
    number: 9,
    word: "stray",
    text: "O Son of Being! My love is My stronghold; he that entereth therein is safe and secure, and he that turneth away shall surely stray and perish.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#204970481",
  },
  {
    id: "arabic-10",
    collection: "arabic",
    number: 10,
    word: "abide",
    text: "O Son of Utterance! Thou art My stronghold; enter therein that thou mayest abide in safety. My love is in thee, know it, that thou mayest find Me near unto thee.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#249830108",
  },
  {
    id: "arabic-11",
    collection: "arabic",
    number: 11,
    word: "light",
    text: "O Son of Being! Thou art My lamp and My light is in thee. Get thou from it thy radiance and seek none other than Me. For I have created thee rich and have bountifully shed My favor upon thee.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#360291284",
  },
  {
    id: "arabic-12",
    collection: "arabic",
    number: 12,
    word: "power",
    text: "O Son of Being! With the hands of power I made thee and with the fingers of strength I created thee; and within thee have I placed the essence of My light. Be thou content with it and seek naught else, for My work is perfect and My command is binding. Question it not, nor have a doubt thereof.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#724175772",
  },
  {
    id: "arabic-13",
    collection: "arabic",
    number: 13,
    word: "abase",
    text: "O Son of Spirit! I created thee rich, why dost thou bring thyself down to poverty? Noble I made thee, wherewith dost thou abase thyself? Out of the essence of knowledge I gave thee being, why seekest thou enlightenment from anyone beside Me? Out of the clay of love I molded thee, how dost thou busy thyself with another? Turn thy sight unto thyself, that thou mayest find Me standing within thee, mighty, powerful and self-subsisting.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#511421653",
  },
  {
    id: "arabic-14",
    collection: "arabic",
    number: 14,
    word: "glory",
    text: "O Son of Man! Thou art My dominion and My dominion perisheth not; wherefore fearest thou thy perishing? Thou art My light and My light shall never be extinguished; why dost thou dread extinction? Thou art My glory and My glory fadeth not; thou art My robe and My robe shall never be outworn. Abide then in thy love for Me, that thou mayest find Me in the realm of glory.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#708223253",
  },
  {
    id: "arabic-15",
    collection: "arabic",
    number: 15,
    word: "quest",
    text: "O Son of Utterance! Turn thy face unto Mine and renounce all save Me; for My sovereignty endureth and My dominion perisheth not. If thou seekest another than Me, yea, if thou searchest the universe forevermore, thy quest will be in vain.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#084945209",
  },
  {
    id: "arabic-16",
    collection: "arabic",
    number: 16,
    word: "light",
    text: "O Son of Light! Forget all save Me and commune with My spirit. This is of the essence of My command, therefore turn unto it.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#326933756",
  },
  {
    id: "arabic-17",
    collection: "arabic",
    number: 17,
    word: "other",
    text: "O Son of Man! Be thou content with Me and seek no other helper. For none but Me can ever suffice thee.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#176729752",
  },
  {
    id: "arabic-18",
    collection: "arabic",
    number: 18,
    word: "which",
    text: "O Son of Spirit! Ask not of Me that which We desire not for thee, then be content with what We have ordained for thy sake, for this is that which profiteth thee, if therewith thou dost content thyself.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#172973975",
  },
  {
    id: "arabic-19",
    collection: "arabic",
    number: 19,
    word: "lover",
    text: "O Son of the Wondrous Vision! I have breathed within thee a breath of My own Spirit, that thou mayest be My lover. Why hast thou forsaken Me and sought a beloved other than Me?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#203478186",
  },
  {
    id: "arabic-20",
    collection: "arabic",
    number: 20,
    word: "claim",
    text: "O Son of Spirit! My claim on thee is great, it cannot be forgotten. My grace to thee is plenteous, it cannot be veiled. My love hath made in thee its home, it cannot be concealed. My light is manifest to thee, it cannot be obscured.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#682988442",
  },
  {
    id: "arabic-21",
    collection: "arabic",
    number: 21,
    word: "realm",
    text: "O Son of Man! Upon the tree of effulgent glory I have hung for thee the choicest fruits, wherefore hast thou turned away and contented thyself with that which is less good? Return then unto that which is better for thee in the realm on high.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#227320942",
  },
  {
    id: "arabic-22",
    collection: "arabic",
    number: 22,
    word: "noble",
    text: "O Son of Spirit! Noble have I created thee, yet thou hast abased thyself. Rise then unto that for which thou wast created.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#536853978",
  },
  {
    id: "arabic-23",
    collection: "arabic",
    number: 23,
    word: "thine",
    text: "O Son of the Supreme! To the eternal I call thee, yet thou dost seek that which perisheth. What hath made thee turn away from Our desire and seek thine own?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#543131747",
  },
  {
    id: "arabic-24",
    collection: "arabic",
    number: 24,
    word: "might",
    text: "O Son of Man! Transgress not thy limits, nor claim that which beseemeth thee not. Prostrate thyself before the countenance of thy God, the Lord of might and power.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#153701502",
  },
  {
    id: "arabic-25",
    collection: "arabic",
    number: 25,
    word: "vaunt",
    text: "O Son of Spirit! Vaunt not thyself over the poor, for I lead him on his way and behold thee in thy evil plight and confound thee forevermore.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#585415953",
  },
  {
    id: "arabic-26",
    collection: "arabic",
    number: 26,
    word: "being",
    text: "O Son of Being! How couldst thou forget thine own faults and busy thyself with the faults of others? Whoso doeth this is accursed of Me.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#568477331",
  },
  {
    id: "arabic-28",
    collection: "arabic",
    number: 28,
    word: "truth",
    text: "O Son of Spirit! Know thou of a truth: He that biddeth men be just and himself committeth iniquity is not of Me, even though he bear My name.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#470987721",
  },
  {
    id: "arabic-29",
    collection: "arabic",
    number: 29,
    word: "being",
    text: "O Son of Being! Ascribe not to any soul that which thou wouldst not have ascribed to thee, and say not that which thou doest not. This is My command unto thee, do thou observe it.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#762019759",
  },
  {
    id: "arabic-31",
    collection: "arabic",
    number: 31,
    word: "death",
    text: "O Son of Being! Bring thyself to account each day ere thou art summoned to a reckoning; for death, unheralded, shall come upon thee and thou shalt be called to give account for thy deeds.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#048313746",
  },
  {
    id: "arabic-32",
    collection: "arabic",
    number: 32,
    word: "death",
    text: "O Son of the Supreme! I have made death a messenger of joy to thee. Wherefore dost thou grieve? I made the light to shed on thee its splendor. Why dost thou veil thyself therefrom?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#674148173",
  },
  {
    id: "arabic-33",
    collection: "arabic",
    number: 33,
    word: "court",
    text: "O Son of Spirit! With the joyful tidings of light I hail thee: rejoice! To the court of holiness I summon thee; abide therein that thou mayest live in peace forevermore.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#687429569",
  },
  {
    id: "arabic-34",
    collection: "arabic",
    number: 34,
    word: "cause",
    text: "O Son of Spirit! The spirit of holiness beareth unto thee the joyful tidings of reunion; wherefore dost thou grieve? The spirit of power confirmeth thee in His cause; why dost thou veil thyself? The light of His countenance doth lead thee; how canst thou go astray?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#955217479",
  },
  {
    id: "arabic-36",
    collection: "arabic",
    number: 36,
    word: "forth",
    text: "O Son of Man! Rejoice in the gladness of thine heart, that thou mayest be worthy to meet Me and to mirror forth My beauty.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#745110864",
  },
  {
    id: "arabic-38",
    collection: "arabic",
    number: 38,
    word: "which",
    text: "O Son of Being! Walk in My statutes for love of Me and deny thyself that which thou desirest if thou seekest My pleasure.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#348139945",
  },
  {
    id: "arabic-40",
    collection: "arabic",
    number: 40,
    word: "space",
    text: "O Son of Man! Wert thou to speed through the immensity of space and traverse the expanse of heaven, yet thou wouldst find no rest save in submission to Our command and humbleness before Our Face.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#815268217",
  },
  {
    id: "arabic-41",
    collection: "arabic",
    number: 41,
    word: "shine",
    text: "O Son of Man! Magnify My cause that I may reveal unto thee the mysteries of My greatness and shine upon thee with the light of eternity.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#847002213",
  },
  {
    id: "arabic-42",
    collection: "arabic",
    number: 42,
    word: "arise",
    text: "O Son of Man! Humble thyself before Me, that I may graciously visit thee. Arise for the triumph of My cause, that while yet on earth thou mayest obtain the victory.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#588699010",
  },
  {
    id: "arabic-43",
    collection: "arabic",
    number: 43,
    word: "earth",
    text: "O Son of Being! Make mention of Me on My earth, that in My heaven I may remember thee, thus shall Mine eyes and thine be solaced.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#483970230",
  },
  {
    id: "arabic-44",
    collection: "arabic",
    number: 44,
    word: "sight",
    text: "O Son of the Throne! Thy hearing is My hearing, hear thou therewith. Thy sight is My sight, do thou see therewith, that in thine inmost soul thou mayest testify unto My exalted sanctity, and I within Myself may bear witness unto an exalted station for thee.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#856926883",
  },
  {
    id: "arabic-45",
    collection: "arabic",
    number: 45,
    word: "glory",
    text: "O Son of Being! Seek a martyr’s death in My path, content with My pleasure and thankful for that which I ordain, that thou mayest repose with Me beneath the canopy of majesty behind the tabernacle of glory.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#900928409",
  },
  {
    id: "arabic-46",
    collection: "arabic",
    number: 46,
    word: "judge",
    text: "O Son of Man! Ponder and reflect. Is it thy wish to die upon thy bed, or to shed thy lifeblood on the dust, a martyr in My path, and so become the manifestation of My command and the revealer of My light in the highest paradise? Judge thou aright, O servant!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#950471653",
  },
  {
    id: "arabic-47",
    collection: "arabic",
    number: 47,
    word: "blood",
    text: "O Son of Man! By My beauty! To tinge thy hair with thy blood is greater in My sight than the creation of the universe and the light of both worlds. Strive then to attain this, O servant!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#147382821",
  },
  {
    id: "arabic-48",
    collection: "arabic",
    number: 48,
    word: "under",
    text: "O Son of Man! For everything there is a sign. The sign of love is fortitude under My decree and patience under My trials.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#200697020",
  },
  {
    id: "arabic-49",
    collection: "arabic",
    number: 49,
    word: "rebel",
    text: "O Son of Man! The true lover yearneth for tribulation even as doth the rebel for forgiveness and the sinful for mercy.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#930638360",
  },
  {
    id: "arabic-50",
    collection: "arabic",
    number: 50,
    word: "light",
    text: "O Son of Man! If adversity befall thee not in My path, how canst thou walk in the ways of them that are content with My pleasure? If trials afflict thee not in thy longing to meet Me, how wilt thou attain the light in thy love for My beauty?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#472999964",
  },
  {
    id: "arabic-51",
    collection: "arabic",
    number: 51,
    word: "mercy",
    text: "O Son of Man! My calamity is My providence, outwardly it is fire and vengeance, but inwardly it is light and mercy. Hasten thereunto that thou mayest become an eternal light and an immortal spirit. This is My command unto thee, do thou observe it.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#746355706",
  },
  {
    id: "arabic-52",
    collection: "arabic",
    number: 52,
    word: "shall",
    text: "O Son of Man! Should prosperity befall thee, rejoice not, and should abasement come upon thee, grieve not, for both shall pass away and be no more.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#118018611",
  },
  {
    id: "arabic-53",
    collection: "arabic",
    number: 53,
    word: "visit",
    text: "O Son of Being! If poverty overtake thee, be not sad; for in time the Lord of wealth shall visit thee. Fear not abasement, for glory shall one day rest on thee.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#956386997",
  },
  {
    id: "arabic-54",
    collection: "arabic",
    number: 54,
    word: "heart",
    text: "O Son of Being! If thine heart be set upon this eternal, imperishable dominion, and this ancient, everlasting life, forsake this mortal and fleeting sovereignty.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#562190408",
  },
  {
    id: "arabic-55",
    collection: "arabic",
    number: 55,
    word: "world",
    text: "O Son of Being! Busy not thyself with this world, for with fire We test the gold, and with gold We test Our servants.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#561352140",
  },
  {
    id: "arabic-56",
    collection: "arabic",
    number: 56,
    word: "fancy",
    text: "O Son of Man! Thou dost wish for gold and I desire thy freedom from it. Thou thinkest thyself rich in its possession, and I recognize thy wealth in thy sanctity therefrom. By My life! This is My knowledge, and that is thy fancy; how can My way accord with thine?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#748392247",
  },
  {
    id: "arabic-57",
    collection: "arabic",
    number: 57,
    word: "offer",
    text: "O Son of Man! Bestow My wealth upon My poor, that in heaven thou mayest draw from stores of unfading splendor and treasures of imperishable glory. But by My life! To offer up thy soul is a more glorious thing couldst thou but see with Mine eye.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#636691280",
  },
  {
    id: "arabic-58",
    collection: "arabic",
    number: 58,
    word: "being",
    text: "O Son of Man! The temple of being is My throne; cleanse it of all things, that there I may be established and there I may abide.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#543261789",
  },
  {
    id: "arabic-59",
    collection: "arabic",
    number: 59,
    word: "place",
    text: "O Son of Being! Thy heart is My home; sanctify it for My descent. Thy spirit is My place of revelation; cleanse it for My manifestation.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#804011987",
  },
  {
    id: "arabic-60",
    collection: "arabic",
    number: 60,
    word: "bosom",
    text: "O Son of Man! Put thy hand into My bosom, that I may rise above thee, radiant and resplendent.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#287468342",
  },
  {
    id: "arabic-61",
    collection: "arabic",
    number: 61,
    word: "quaff",
    text: "O Son of Man! Ascend unto My heaven, that thou mayest obtain the joy of reunion, and from the chalice of imperishable glory quaff the peerless wine.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#755666283",
  },
  {
    id: "arabic-62",
    collection: "arabic",
    number: 62,
    word: "risen",
    text: "O Son of Man! Many a day hath passed over thee whilst thou hast busied thyself with thy fancies and idle imaginings. How long art thou to slumber on thy bed? Lift up thy head from slumber, for the Sun hath risen to the zenith, haply it may shine upon thee with the light of beauty.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#677243732",
  },
  {
    id: "arabic-63",
    collection: "arabic",
    number: 63,
    word: "shone",
    text: "O Son of Man! The light hath shone on thee from the horizon of the sacred Mount and the spirit of enlightenment hath breathed in the Sinai of thy heart. Wherefore, free thyself from the veils of idle fancies and enter into My court, that thou mayest be fit for everlasting life and worthy to meet Me. Thus may death not come upon thee, neither weariness nor trouble.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#244905205",
  },
  {
    id: "arabic-64",
    collection: "arabic",
    number: 64,
    word: "unity",
    text: "O Son of Man! My eternity is My creation, I have created it for thee. Make it the garment of thy temple. My unity is My handiwork; I have wrought it for thee; clothe thyself therewith, that thou mayest be to all eternity the revelation of My everlasting being.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#101409766",
  },
  {
    id: "arabic-65",
    collection: "arabic",
    number: 65,
    word: "token",
    text: "O Son of Man! My majesty is My gift to thee, and My grandeur the token of My mercy unto thee. That which beseemeth Me none shall understand, nor can anyone recount. Verily, I have preserved it in My hidden storehouses and in the treasuries of My command, as a sign of My loving-kindness unto My servants and My mercy unto My people.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#439014978",
  },
  {
    id: "arabic-66",
    collection: "arabic",
    number: 66,
    word: "minds",
    text: "O Children of the Divine and Invisible Essence! Ye shall be hindered from loving Me and souls shall be perturbed as they make mention of Me. For minds cannot grasp Me nor hearts contain Me.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#716805208",
  },
  {
    id: "arabic-67",
    collection: "arabic",
    number: 67,
    word: "voice",
    text: "O Son of Beauty! By My spirit and by My favor! By My mercy and by My beauty! All that I have revealed unto thee with the tongue of power, and have written for thee with the pen of might, hath been in accordance with thy capacity and understanding, not with My state and the melody of My voice.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#044427246",
  },
  {
    id: "arabic-68",
    collection: "arabic",
    number: 68,
    word: "exalt",
    text: "O Children of Men! Know ye not why We created you all from the same dust? That no one should exalt himself over the other. Ponder at all times in your hearts how ye were created. Since We have created you all from one same substance it is incumbent on you to be even as one soul, to walk with the same feet, eat with the same mouth and dwell in the same land, that from your inmost being, by your deeds and actions, the signs of oneness and the essence of detachment may be made manifest. Such is My counsel to you, O concourse of light! Heed ye this counsel that ye may obtain the fruit of holiness from the tree of wondrous glory.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#685666862",
  },
  {
    id: "arabic-69",
    collection: "arabic",
    number: 69,
    word: "guard",
    text: "O Ye Sons of Spirit! Ye are My treasury, for in you I have treasured the pearls of My mysteries and the gems of My knowledge. Guard them from the strangers amidst My servants and from the ungodly amongst My people.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#414744315",
  },
  {
    id: "arabic-70",
    collection: "arabic",
    number: 70,
    word: "stood",
    text: "O Son of Him that Stood by His Own Entity in the Kingdom of His Self! Know thou, that I have wafted unto thee all the fragrances of holiness, have fully revealed to thee My word, have perfected through thee My bounty and have desired for thee that which I have desired for My Self. Be then content with My pleasure and thankful unto Me.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#186817587",
  },
  {
    id: "arabic-71",
    collection: "arabic",
    number: 71,
    word: "write",
    text: "O Son of Man! Write all that We have revealed unto thee with the ink of light upon the tablet of thy spirit. Should this not be in thy power, then make thine ink of the essence of thy heart. If this thou canst not do, then write with that crimson ink that hath been shed in My path. Sweeter indeed is this to Me than all else, that its light may endure forever.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/2#296667998",
  },
  {
    id: "persian-1",
    collection: "persian",
    number: 1,
    word: "wings",
    text: "O Ye People that Have Minds to Know and Ears to Hear! The first call of the Beloved is this: O mystic nightingale! Abide not but in the rose garden of the spirit. O messenger of the Solomon of love! Seek thou no shelter except in the Sheba of the well-beloved, and O immortal phoenix! dwell not save on the mount of faithfulness. Therein is thy habitation, if on the wings of thy soul thou soarest to the realm of the infinite and seekest to attain thy goal.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#099391514",
  },
  {
    id: "persian-2",
    collection: "persian",
    number: 2,
    word: "birds",
    text: "O Son of Spirit! The bird seeketh its nest; the nightingale the charm of the rose; whilst those birds, the hearts of men, content with transient dust, have strayed far from their eternal nest, and with eyes turned towards the slough of heedlessness are bereft of the glory of the divine presence. Alas! How strange and pitiful; for a mere cupful, they have turned away from the billowing seas of the Most High, and remained far from the most effulgent horizon.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#775010913",
  },
  {
    id: "persian-3",
    collection: "persian",
    number: 3,
    word: "plant",
    text: "O Friend! In the garden of thy heart plant naught but the rose of love, and from the nightingale of affection and desire loosen not thy hold. Treasure the companionship of the righteous and eschew all fellowship with the ungodly.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#607855955",
  },
  {
    id: "persian-4",
    collection: "persian",
    number: 4,
    word: "abode",
    text: "O Son of Justice! Whither can a lover go but to the land of his beloved? and what seeker findeth rest away from his heart’s desire? To the true lover reunion is life, and separation is death. His breast is void of patience and his heart hath no peace. A myriad lives he would forsake to hasten to the abode of his beloved.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#445619358",
  },
  {
    id: "persian-5",
    collection: "persian",
    number: 5,
    word: "words",
    text: "O Son of Dust! Verily I say unto thee: Of all men the most negligent is he that disputeth idly and seeketh to advance himself over his brother. Say: O brethren! Let deeds, not words, be your adorning.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#646280975",
  },
  {
    id: "persian-6",
    collection: "persian",
    number: 6,
    word: "sweet",
    text: "O Son of Earth! Know, verily, the heart wherein the least remnant of envy yet lingereth, shall never attain My everlasting dominion, nor inhale the sweet savors of holiness breathing from My kingdom of sanctity.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#909712031",
  },
  {
    id: "persian-7",
    collection: "persian",
    number: 7,
    word: "above",
    text: "O Son of Love! Thou art but one step away from the glorious heights above and from the celestial tree of love. Take thou one pace and with the next advance into the immortal realm and enter the pavilion of eternity. Give ear then to that which hath been revealed by the Pen of Glory.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#866203931",
  },
  {
    id: "persian-8",
    collection: "persian",
    number: 8,
    word: "swift",
    text: "O Son of Glory! Be swift in the path of holiness, and enter the heaven of communion with Me. Cleanse thy heart with the burnish of the spirit, and hasten to the court of the Most High.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#105970176",
  },
  {
    id: "persian-9",
    collection: "persian",
    number: 9,
    word: "doubt",
    text: "O Fleeting Shadow! Pass beyond the baser stages of doubt and rise to the exalted heights of certainty. Open the eye of truth, that thou mayest behold the veilless Beauty and exclaim: Hallowed be the Lord, the most excellent of all creators!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#484615704",
  },
  {
    id: "persian-10",
    collection: "persian",
    number: 10,
    word: "bloom",
    text: "O Son of Desire! Give ear unto this: Never shall mortal eye recognize the everlasting Beauty, nor the lifeless heart delight in aught but in the withered bloom. For like seeketh like, and taketh pleasure in the company of its kind.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#915407365",
  },
  {
    id: "persian-11",
    collection: "persian",
    number: 11,
    word: "blind",
    text: "O Son of Dust! Blind thine eyes, that thou mayest behold My beauty; stop thine ears, that thou mayest hearken unto the sweet melody of My voice; empty thyself of all learning, that thou mayest partake of My knowledge; and sanctify thyself from riches, that thou mayest obtain a lasting share from the ocean of My eternal wealth. Blind thine eyes, that is, to all save My beauty; stop thine ears to all save My word; empty thyself of all learning save the knowledge of Me; that with a clear vision, a pure heart and an attentive ear thou mayest enter the court of My holiness.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#756281961",
  },
  {
    id: "persian-12",
    collection: "persian",
    number: 12,
    word: "close",
    text: "O Man of Two Visions! Close one eye and open the other. Close one to the world and all that is therein, and open the other to the hallowed beauty of the Beloved.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#775762706",
  },
  {
    id: "persian-13",
    collection: "persian",
    number: 13,
    word: "gazed",
    text: "O My Children! I fear lest, bereft of the melody of the dove of heaven, ye will sink back to the shades of utter loss, and, never having gazed upon the beauty of the rose, return to water and clay.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#944463388",
  },
  {
    id: "persian-14",
    collection: "persian",
    number: 14,
    word: "world",
    text: "O Friends! Abandon not the everlasting beauty for a beauty that must die, and set not your affections on this mortal world of dust.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#909085672",
  },
  {
    id: "persian-15",
    collection: "persian",
    number: 15,
    word: "inner",
    text: "O Son of Spirit! The time cometh, when the nightingale of holiness will no longer unfold the inner mysteries and ye will all be bereft of the celestial melody and of the voice from on high.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#411149860",
  },
  {
    id: "persian-16",
    collection: "persian",
    number: 16,
    word: "heart",
    text: "O Essence of Negligence! Myriads of mystic tongues find utterance in one speech, and myriads of hidden mysteries are revealed in a single melody; yet, alas, there is no ear to hear, nor heart to understand.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#748143718",
  },
  {
    id: "persian-17",
    collection: "persian",
    number: 17,
    word: "gates",
    text: "O Comrades! The gates that open on the Placeless stand wide and the habitation of the loved one is adorned with the lovers’ blood, yet all but a few remain bereft of this celestial city, and even of these few, none but the smallest handful hath been found with a pure heart and sanctified spirit.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#304654598",
  },
  {
    id: "persian-18",
    collection: "persian",
    number: 18,
    word: "learn",
    text: "O Ye Dwellers in the Highest Paradise! Proclaim unto the children of assurance that within the realms of holiness, nigh unto the celestial paradise, a new garden hath appeared, round which circle the denizens of the realm on high and the immortal dwellers of the exalted paradise. Strive, then, that ye may attain that station, that ye may unravel the mysteries of love from its windflowers and learn the secret of divine and consummate wisdom from its eternal fruits. Solaced are the eyes of them that enter and abide therein!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#915681675",
  },
  {
    id: "persian-19",
    collection: "persian",
    number: 19,
    word: "shade",
    text: "O My Friends! Have ye forgotten that true and radiant morn, when in those hallowed and blessed surroundings ye were all gathered in My presence beneath the shade of the tree of life, which is planted in the all-glorious paradise? Awestruck ye listened as I gave utterance to these three most holy words: O friends! Prefer not your will to Mine, never desire that which I have not desired for you, and approach Me not with lifeless hearts, defiled with worldly desires and cravings. Would ye but sanctify your souls, ye would at this present hour recall that place and those surroundings, and the truth of My utterance should be made evident unto all of you.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#069414826",
  },
  {
    id: "persian-20",
    collection: "persian",
    number: 20,
    word: "faith",
    text: "O Ye That Are Lying as Dead on the Couch of Heedlessness! Ages have passed and your precious lives are well-nigh ended, yet not a single breath of purity hath reached Our court of holiness from you. Though immersed in the ocean of misbelief, yet with your lips ye profess the one true faith of God. Him whom I abhor ye have loved, and of My foe ye have made a friend. Notwithstanding, ye walk on My earth complacent and self-satisfied, heedless that My earth is weary of you and everything within it shunneth you. Were ye but to open your eyes, ye would, in truth, prefer a myriad griefs unto this joy, and would count death itself better than this life.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#824146051",
  },
  {
    id: "persian-21",
    collection: "persian",
    number: 21,
    word: "sword",
    text: "O Moving Form of Dust! I desire communion with thee, but thou wouldst put no trust in Me. The sword of thy rebellion hath felled the tree of thy hope. At all times I am near unto thee, but thou art ever far from Me. Imperishable glory I have chosen for thee, yet boundless shame thou hast chosen for thyself. While there is yet time, return, and lose not thy chance.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#492712156",
  },
  {
    id: "persian-22",
    collection: "persian",
    number: 22,
    word: "touch",
    text: "O Son of Desire! The learned and the wise have for long years striven and failed to attain the presence of the All-Glorious; they have spent their lives in search of Him, yet did not behold the beauty of His countenance. Thou without the least effort didst attain thy goal, and without search hast obtained the object of thy quest. Yet, notwithstanding, thou didst remain so wrapt in the veil of self, that thine eyes beheld not the beauty of the Beloved, nor did thy hand touch the hem of His robe. Ye that have eyes, behold and wonder.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#475255532",
  },
  {
    id: "persian-23",
    collection: "persian",
    number: 23,
    word: "youth",
    text: "O Dwellers in the City of Love! Mortal blasts have beset the everlasting candle, and the beauty of the celestial Youth is veiled in the darkness of dust. The chief of the monarchs of love is wronged by the people of tyranny and the dove of holiness lieth prisoned in the talons of owls. The dwellers in the pavilion of glory and the celestial concourse bewail and lament, while ye repose in the realm of negligence, and esteem yourselves as of the true friends. How vain are your imaginings!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#927133713",
  },
  {
    id: "persian-24",
    collection: "persian",
    number: 24,
    word: "flock",
    text: "O Ye That Are Foolish, Yet Have a Name to Be Wise! Wherefore do ye wear the guise of shepherds, when inwardly ye have become wolves, intent upon My flock? Ye are even as the star, which riseth ere the dawn, and which, though it seem radiant and luminous, leadeth the wayfarers of My city astray into the paths of perdition.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#904750204",
  },
  {
    id: "persian-25",
    collection: "persian",
    number: 25,
    word: "water",
    text: "O Ye Seeming Fair Yet Inwardly Foul! Ye are like clear but bitter water, which to outward seeming is crystal pure but of which, when tested by the divine Assayer, not a drop is accepted. Yea, the sunbeam falleth alike upon the dust and the mirror, yet differ they in reflection even as doth the star from the earth: nay, immeasurable is the difference!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#947541230",
  },
  {
    id: "persian-26",
    collection: "persian",
    number: 26,
    word: "enter",
    text: "O My Friend in Word! Ponder awhile. Hast thou ever heard that friend and foe should abide in one heart? Cast out then the stranger, that the Friend may enter His home.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#676488956",
  },
  {
    id: "persian-27",
    collection: "persian",
    number: 27,
    word: "human",
    text: "O Son of Dust! All that is in heaven and earth I have ordained for thee, except the human heart, which I have made the habitation of My beauty and glory; yet thou didst give My home and dwelling to another than Me; and whenever the manifestation of My holiness sought His own abode, a stranger found He there, and, homeless, hastened unto the sanctuary of the Beloved. Notwithstanding I have concealed thy secret and desired not thy shame.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#326525665",
  },
  {
    id: "persian-28",
    collection: "persian",
    number: 28,
    word: "flash",
    text: "O Essence of Desire! At many a dawn have I turned from the realms of the Placeless unto thine abode, and found thee on the bed of ease busied with others than Myself. Thereupon, even as the flash of the spirit, I returned to the realms of celestial glory and breathed it not in My retreats above unto the hosts of holiness.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#642676691",
  },
  {
    id: "persian-29",
    collection: "persian",
    number: 29,
    word: "grace",
    text: "O Son of Bounty! Out of the wastes of nothingness, with the clay of My command I made thee to appear, and have ordained for thy training every atom in existence and the essence of all created things. Thus, ere thou didst issue from thy mother’s womb, I destined for thee two founts of gleaming milk, eyes to watch over thee, and hearts to love thee. Out of My loving-kindness, ’neath the shade of My mercy I nurtured thee, and guarded thee by the essence of My grace and favor. And My purpose in all this was that thou mightest attain My everlasting dominion and become worthy of My invisible bestowals. And yet heedless thou didst remain, and when fully grown, thou didst neglect all My bounties and occupied thyself with thine idle imaginings, in such wise that thou didst become wholly forgetful, and, turning away from the portals of the Friend didst abide within the courts of My enemy.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#567841905",
  },
  {
    id: "persian-30",
    collection: "persian",
    number: 30,
    word: "found",
    text: "O Bondslave of the World! Many a dawn hath the breeze of My loving-kindness wafted over thee and found thee upon the bed of heedlessness fast asleep. Bewailing then thy plight it returned whence it came.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#931320080",
  },
  {
    id: "persian-31",
    collection: "persian",
    number: 31,
    word: "dwell",
    text: "O Son of Earth! Wouldst thou have Me, seek none other than Me; and wouldst thou gaze upon My beauty, close thine eyes to the world and all that is therein; for My will and the will of another than Me, even as fire and water, cannot dwell together in one heart.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#809848791",
  },
  {
    id: "persian-32",
    collection: "persian",
    number: 32,
    word: "winds",
    text: "O Befriended Stranger! The candle of thine heart is lighted by the hand of My power, quench it not with the contrary winds of self and passion. The healer of all thine ills is remembrance of Me, forget it not. Make My love thy treasure and cherish it even as thy very sight and life.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#889172469",
  },
  {
    id: "persian-33",
    collection: "persian",
    number: 33,
    word: "seeds",
    text: "O My Brother! Hearken to the delightsome words of My honeyed tongue, and quaff the stream of mystic holiness from My sugar-shedding lips. Sow the seeds of My divine wisdom in the pure soil of thy heart, and water them with the water of certitude, that the hyacinths of My knowledge and wisdom may spring up fresh and green in the sacred city of thy heart.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#725404749",
  },
  {
    id: "persian-34",
    collection: "persian",
    number: 34,
    word: "flame",
    text: "O Dwellers of My Paradise! With the hands of loving-kindness I have planted in the holy garden of paradise the young tree of your love and friendship, and have watered it with the goodly showers of My tender grace; now that the hour of its fruiting is come, strive that it may be protected, and be not consumed with the flame of desire and passion.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#478336069",
  },
  {
    id: "persian-35",
    collection: "persian",
    number: 35,
    word: "torch",
    text: "O My Friends! Quench ye the lamp of error, and kindle within your hearts the everlasting torch of divine guidance. For ere long the assayers of mankind shall, in the holy presence of the Adored, accept naught but purest virtue and deeds of stainless holiness.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#839248912",
  },
  {
    id: "persian-36",
    collection: "persian",
    number: 36,
    word: "speak",
    text: "O Son of Dust! The wise are they that speak not unless they obtain a hearing, even as the cup-bearer, who proffereth not his cup till he findeth a seeker, and the lover who crieth not out from the depths of his heart until he gazeth upon the beauty of his beloved. Wherefore sow the seeds of wisdom and knowledge in the pure soil of the heart, and keep them hidden, till the hyacinths of divine wisdom spring from the heart and not from mire and clay.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#447289253",
  },
  {
    id: "persian-37",
    collection: "persian",
    number: 37,
    word: "river",
    text: "O My Servant! Abandon not for that which perisheth an everlasting dominion, and cast not away celestial sovereignty for a worldly desire. This is the river of everlasting life that hath flowed from the wellspring of the pen of the merciful; well is it with them that drink!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#998408191",
  },
  {
    id: "persian-38",
    collection: "persian",
    number: 38,
    word: "burst",
    text: "O Son of Spirit! Burst thy cage asunder, and even as the phoenix of love soar into the firmament of holiness. Renounce thyself and, filled with the spirit of mercy, abide in the realm of celestial sanctity.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#988131543",
  },
  {
    id: "persian-39",
    collection: "persian",
    number: 39,
    word: "above",
    text: "O Offspring of Dust! Be not content with the ease of a passing day, and deprive not thyself of everlasting rest. Barter not the garden of eternal delight for the dust-heap of a mortal world. Up from thy prison ascend unto the glorious meads above, and from thy mortal cage wing thy flight unto the paradise of the Placeless.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#921804077",
  },
  {
    id: "persian-40",
    collection: "persian",
    number: 40,
    word: "seize",
    text: "O My Servant! Free thyself from the fetters of this world, and loose thy soul from the prison of self. Seize thy chance, for it will come to thee no more.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#178899283",
  },
  {
    id: "persian-41",
    collection: "persian",
    number: 41,
    word: "heart",
    text: "O Son of My Handmaid! Didst thou behold immortal sovereignty, thou wouldst strive to pass from this fleeting world. But to conceal the one from thee and to reveal the other is a mystery which none but the pure in heart can comprehend.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#228576295",
  },
  {
    id: "persian-42",
    collection: "persian",
    number: 42,
    word: "purge",
    text: "O My Servant! Purge thy heart from malice and, innocent of envy, enter the divine court of holiness.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#006213096",
  },
  {
    id: "persian-43",
    collection: "persian",
    number: 43,
    word: "house",
    text: "O My Friends! Walk ye in the ways of the good pleasure of the Friend, and know that His pleasure is in the pleasure of His creatures. That is: no man should enter the house of his friend save at his friend’s pleasure, nor lay hands upon his treasures nor prefer his own will to his friend’s, and in no wise seek an advantage over him. Ponder this, ye that have insight!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#452186269",
  },
  {
    id: "persian-44",
    collection: "persian",
    number: 44,
    word: "frame",
    text: "O Companion of My Throne! Hear no evil, and see no evil, abase not thyself, neither sigh and weep. Speak no evil, that thou mayest not hear it spoken unto thee, and magnify not the faults of others that thine own faults may not appear great; and wish not the abasement of anyone, that thine own abasement be not exposed. Live then the days of thy life, that are less than a fleeting moment, with thy mind stainless, thy heart unsullied, thy thoughts pure, and thy nature sanctified, so that, free and content, thou mayest put away this mortal frame, and repair unto the mystic paradise and abide in the eternal kingdom forevermore.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#697759113",
  },
  {
    id: "persian-45",
    collection: "persian",
    number: 45,
    word: "thorn",
    text: "Alas! Alas! O Lovers of Worldly Desire! Even as the swiftness of lightning ye have passed by the Beloved One, and have set your hearts on satanic fancies. Ye bow the knee before your vain imagining, and call it truth. Ye turn your eyes towards the thorn, and name it a flower. Not a pure breath have ye breathed, nor hath the breeze of detachment been wafted from the meadows of your hearts. Ye have cast to the winds the loving counsels of the Beloved and have effaced them utterly from the tablet of your hearts, and even as the beasts of the field, ye move and have your being within the pastures of desire and passion.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#577977380",
  },
  {
    id: "persian-46",
    collection: "persian",
    number: 46,
    word: "sweet",
    text: "O Brethren in the Path! Wherefore have ye neglected the mention of the Loved One, and kept remote from His holy presence? The essence of beauty is within the peerless pavilion, set upon the throne of glory, whilst ye busy yourselves with idle contentions. The sweet savors of holiness are breathing and the breath of bounty is wafted, yet ye are all sorely afflicted and deprived thereof. Alas for you and for them that walk in your ways and follow in your footsteps!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#076998102",
  },
  {
    id: "persian-48",
    collection: "persian",
    number: 48,
    word: "pride",
    text: "O Brethren! Be forbearing one with another and set not your affections on things below. Pride not yourselves in your glory, and be not ashamed of abasement. By My beauty! I have created all things from dust, and to dust will I return them again.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#410608045",
  },
  {
    id: "persian-50",
    collection: "persian",
    number: 50,
    word: "loved",
    text: "O Quintessence of Passion! Put away all covetousness and seek contentment; for the covetous hath ever been deprived, and the contented hath ever been loved and praised.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#089879189",
  },
  {
    id: "persian-51",
    collection: "persian",
    number: 51,
    word: "value",
    text: "O Son of My Handmaid! Be not troubled in poverty nor confident in riches, for poverty is followed by riches, and riches are followed by poverty. Yet to be poor in all save God is a wondrous gift, belittle not the value thereof, for in the end it will make thee rich in God, and thus thou shalt know the meaning of the utterance, “In truth ye are the poor,” and the holy words, “God is the all-possessing,” shall even as the true morn break forth gloriously resplendent upon the horizon of the lover’s heart, and abide secure on the throne of wealth.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#937503023",
  },
  {
    id: "persian-52",
    collection: "persian",
    number: 52,
    word: "enemy",
    text: "O Children of Negligence and Passion! Ye have suffered My enemy to enter My house and have cast out My friend, for ye have enshrined the love of another than Me in your hearts. Give ear to the sayings of the Friend and turn towards His paradise. Worldly friends, seeking their own good, appear to love one the other, whereas the true Friend hath loved and doth love you for your own sakes; indeed He hath suffered for your guidance countless afflictions. Be not disloyal to such a Friend, nay rather hasten unto Him. Such is the daystar of the word of truth and faithfulness, that hath dawned above the horizon of the pen of the Lord of all names. Open your ears that ye may hearken unto the word of God, the Help in peril, the Self-Existent.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#564055916",
  },
  {
    id: "persian-53",
    collection: "persian",
    number: 53,
    word: "great",
    text: "O Ye that Pride Yourselves on Mortal Riches! Know ye in truth that wealth is a mighty barrier between the seeker and his desire, the lover and his beloved. The rich, but for a few, shall in no wise attain the court of His presence nor enter the city of content and resignation. Well is it then with him, who, being rich, is not hindered by his riches from the eternal kingdom, nor deprived by them of imperishable dominion. By the Most Great Name! The splendor of such a wealthy man shall illuminate the dwellers of heaven even as the sun enlighteneth the people of the earth!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#305325189",
  },
  {
    id: "persian-54",
    collection: "persian",
    number: 54,
    word: "trust",
    text: "O Ye Rich Ones on Earth! The poor in your midst are My trust; guard ye My trust, and be not intent only on your own ease.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#278984163",
  },
  {
    id: "persian-55",
    collection: "persian",
    number: 55,
    word: "peace",
    text: "O Son of Passion! Cleanse thyself from the defilement of riches and in perfect peace advance into the realm of poverty; that from the wellspring of detachment thou mayest quaff the wine of immortal life.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#801572056",
  },
  {
    id: "persian-56",
    collection: "persian",
    number: 56,
    word: "words",
    text: "O My Son! The company of the ungodly increaseth sorrow, whilst fellowship with the righteous cleanseth the rust from off the heart. He that seeketh to commune with God, let him betake himself to the companionship of His loved ones; and he that desireth to hearken unto the word of God, let him give ear to the words of His chosen ones.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#289429069",
  },
  {
    id: "persian-57",
    collection: "persian",
    number: 57,
    word: "heart",
    text: "O Son of Dust! Beware! Walk not with the ungodly and seek not fellowship with him, for such companionship turneth the radiance of the heart into infernal fire.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#801831638",
  },
  {
    id: "persian-58",
    collection: "persian",
    number: 58,
    word: "drunk",
    text: "O Son of My Handmaid! Wouldst thou seek the grace of the Holy Spirit, enter into fellowship with the righteous, for he hath drunk the cup of eternal life at the hands of the immortal Cupbearer and even as the true morn doth quicken and illumine the hearts of the dead.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#628305516",
  },
  {
    id: "persian-59",
    collection: "persian",
    number: 59,
    word: "think",
    text: "O Heedless Ones! Think not the secrets of hearts are hidden, nay, know ye of a certainty that in clear characters they are engraved and are openly manifest in the holy Presence.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#605312464",
  },
  {
    id: "persian-60",
    collection: "persian",
    number: 60,
    word: "grace",
    text: "O Friends! Verily I say, whatsoever ye have concealed within your hearts is to Us open and manifest as the day; but that it is hidden is of Our grace and favor, and not of your deserving.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#640297357",
  },
  {
    id: "persian-61",
    collection: "persian",
    number: 61,
    word: "ocean",
    text: "O Son of Man! A dewdrop out of the fathomless ocean of My mercy I have shed upon the peoples of the world, yet found none turn thereunto, inasmuch as everyone hath turned away from the celestial wine of unity unto the foul dregs of impurity, and, content with mortal cup, hath put away the chalice of immortal beauty. Vile is that wherewith he is contented.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#814768124",
  },
  {
    id: "persian-62",
    collection: "persian",
    number: 62,
    word: "dregs",
    text: "O Son of Dust! Turn not away thine eyes from the matchless wine of the immortal Beloved, and open them not to foul and mortal dregs. Take from the hands of the divine Cupbearer the chalice of immortal life, that all wisdom may be thine, and that thou mayest hearken unto the mystic voice calling from the realm of the invisible. Cry aloud, ye that are of low aim! Wherefore have ye turned away from My holy and immortal wine unto evanescent water?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#718768059",
  },
  {
    id: "persian-63",
    collection: "persian",
    number: 63,
    word: "think",
    text: "O Ye Peoples of the World! Know, verily, that an unforeseen calamity followeth you, and grievous retribution awaiteth you. Think not that which ye have committed hath been effaced in My sight. By My beauty! All your doings hath My pen graven with open characters upon tablets of chrysolite.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#626369506",
  },
  {
    id: "persian-64",
    collection: "persian",
    number: 64,
    word: "hands",
    text: "O Oppressors on Earth! Withdraw your hands from tyranny, for I have pledged Myself not to forgive any man’s injustice. This is My covenant which I have irrevocably decreed in the preserved tablet and sealed with My seal of glory.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#213141042",
  },
  {
    id: "persian-65",
    collection: "persian",
    number: 65,
    word: "fiery",
    text: "O Rebellious Ones! My forbearance hath emboldened you and My long-suffering hath made you negligent, in such wise that ye have spurred on the fiery charger of passion into perilous ways that lead unto destruction. Have ye thought Me heedless or that I was unaware?",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#028529394",
  },
  {
    id: "persian-66",
    collection: "persian",
    number: 66,
    word: "every",
    text: "O Emigrants! The tongue I have designed for the mention of Me, defile it not with detraction. If the fire of self overcome you, remember your own faults and not the faults of My creatures, inasmuch as every one of you knoweth his own self better than he knoweth others.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#062883030",
  },
  {
    id: "persian-67",
    collection: "persian",
    number: 67,
    word: "gloom",
    text: "O Children of Fancy! Know, verily, that while the radiant dawn breaketh above the horizon of eternal holiness, the satanic secrets and deeds done in the gloom of night shall be laid bare and manifest before the peoples of the world.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#807401042",
  },
  {
    id: "persian-68",
    collection: "persian",
    number: 68,
    word: "first",
    text: "O Weed that Springeth Out of Dust! Wherefore have not these soiled hands of thine touched first thine own garment, and why with thine heart defiled with desire and passion dost thou seek to commune with Me and to enter My sacred realm? Far, far are ye from that which ye desire.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#737972628",
  },
  {
    id: "persian-69",
    collection: "persian",
    number: 69,
    word: "favor",
    text: "O Children of Adam! Holy words and pure and goodly deeds ascend unto the heaven of celestial glory. Strive that your deeds may be cleansed from the dust of self and hypocrisy and find favor at the court of glory; for ere long the assayers of mankind shall, in the holy presence of the Adored One, accept naught but absolute virtue and deeds of stainless purity. This is the daystar of wisdom and of divine mystery that hath shone above the horizon of the divine will. Blessed are they that turn thereunto.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#810818726",
  },
  {
    id: "persian-70",
    collection: "persian",
    number: 70,
    word: "freed",
    text: "O Son of Worldliness! Pleasant is the realm of being, wert thou to attain thereto; glorious is the domain of eternity, shouldst thou pass beyond the world of mortality; sweet is the holy ecstasy if thou drinkest of the mystic chalice from the hands of the celestial Youth. Shouldst thou attain this station, thou wouldst be freed from destruction and death, from toil and sin.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#400714616",
  },
  {
    id: "persian-71",
    collection: "persian",
    number: 71,
    word: "trace",
    text: "O My Friends! Call ye to mind that covenant ye have entered into with Me upon Mount Párán, situate within the hallowed precincts of Zamán. I have taken to witness the concourse on high and the dwellers in the city of eternity, yet now none do I find faithful unto the covenant. Of a certainty pride and rebellion have effaced it from the hearts, in such wise that no trace thereof remaineth. Yet knowing this, I waited and disclosed it not.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#750932930",
  },
  {
    id: "persian-72",
    collection: "persian",
    number: 72,
    word: "worth",
    text: "O My Servant! Thou art even as a finely tempered sword concealed in the darkness of its sheath and its value hidden from the artificer’s knowledge. Wherefore come forth from the sheath of self and desire that thy worth may be made resplendent and manifest unto all the world.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#261142065",
  },
  {
    id: "persian-73",
    collection: "persian",
    number: 73,
    word: "array",
    text: "O My Friend! Thou art the daystar of the heavens of My holiness, let not the defilement of the world eclipse thy splendor. Rend asunder the veil of heedlessness, that from behind the clouds thou mayest emerge resplendent and array all things with the apparel of life.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#369559272",
  },
  {
    id: "persian-74",
    collection: "persian",
    number: 74,
    word: "color",
    text: "O Children of Vainglory! For a fleeting sovereignty ye have abandoned My imperishable dominion, and have adorned yourselves with the gay livery of the world and made of it your boast. By My beauty! All will I gather beneath the one-colored covering of the dust and efface all these diverse colors save them that choose My own, and that is purging from every color.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#077330259",
  },
  {
    id: "persian-75",
    collection: "persian",
    number: 75,
    word: "bough",
    text: "O Children of Negligence! Set not your affections on mortal sovereignty and rejoice not therein. Ye are even as the unwary bird that with full confidence warbleth upon the bough; till of a sudden the fowler Death throweth it upon the dust, and the melody, the form and the color are gone, leaving not a trace. Wherefore take heed, O bondslaves of desire!",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#783843342",
  },
  {
    id: "persian-76",
    collection: "persian",
    number: 76,
    word: "deeds",
    text: "O Son of My Handmaid! Guidance hath ever been given by words, and now it is given by deeds. Everyone must show forth deeds that are pure and holy, for words are the property of all alike, whereas such deeds as these belong only to Our loved ones. Strive then with heart and soul to distinguish yourselves by your deeds. In this wise We counsel you in this holy and resplendent tablet.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#358991785",
  },
  {
    id: "persian-77",
    collection: "persian",
    number: 77,
    word: "doves",
    text: "O Son of Justice! In the night-season the beauty of the immortal Being hath repaired from the emerald height of fidelity unto the Sadratu’l-Muntahá, and wept with such a weeping that the concourse on high and the dwellers of the realms above wailed at His lamenting. Whereupon there was asked, Why the wailing and weeping? He made reply: As bidden I waited expectant upon the hill of faithfulness, yet inhaled not from them that dwell on earth the fragrance of fidelity. Then summoned to return I beheld, and lo! certain doves of holiness were sore tried within the claws of the dogs of earth. Thereupon the Maid of heaven hastened forth unveiled and resplendent from Her mystic mansion, and asked of their names, and all were told but one. And when urged, the first letter thereof was uttered, whereupon the dwellers of the celestial chambers rushed forth out of their habitation of glory. And whilst the second letter was pronounced they fell down, one and all, upon the dust. At that moment a voice was heard from the inmost shrine: “Thus far and no farther.” Verily We bear witness to that which they have done and now are doing.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#815379093",
  },
  {
    id: "persian-78",
    collection: "persian",
    number: 78,
    word: "green",
    text: "O Son of My Handmaid! Quaff from the tongue of the merciful the stream of divine mystery, and behold from the dayspring of divine utterance the unveiled splendor of the daystar of wisdom. Sow the seeds of My divine wisdom in the pure soil of the heart, and water them with the waters of certitude, that the hyacinths of knowledge and wisdom may spring up fresh and green from the holy city of the heart.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#733813371",
  },
  {
    id: "persian-79",
    collection: "persian",
    number: 79,
    word: "raven",
    text: "O Son of Desire! How long wilt thou soar in the realms of desire? Wings have I bestowed upon thee, that thou mayest fly to the realms of mystic holiness and not the regions of satanic fancy. The comb, too, have I given thee that thou mayest dress My raven locks, and not lacerate My throat.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#492899806",
  },
  {
    id: "persian-80",
    collection: "persian",
    number: 80,
    word: "fruit",
    text: "O My Servants! Ye are the trees of My garden; ye must give forth goodly and wondrous fruits, that ye yourselves and others may profit therefrom. Thus it is incumbent on every one to engage in crafts and professions, for therein lieth the secret of wealth, O men of understanding! For results depend upon means, and the grace of God shall be all-sufficient unto you. Trees that yield no fruit have been and will ever be for the fire.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#119659976",
  },
  {
    id: "persian-81",
    collection: "persian",
    number: 81,
    word: "yield",
    text: "O My Servant! The basest of men are they that yield no fruit on earth. Such men are verily counted as among the dead, nay better are the dead in the sight of God than those idle and worthless souls.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#468470133",
  },
  {
    id: "persian-82",
    collection: "persian",
    number: 82,
    word: "spend",
    text: "O My Servant! The best of men are they that earn a livelihood by their calling and spend upon themselves and upon their kindred for the love of God, the Lord of all worlds.",
    link: "https://www.bahai.org/library/authoritative-texts/bahaullah/hidden-words/3#002944255",
  },
]

// Seeded Fisher-Yates permutation (mulberry32, seed 0x1a2b3c4d) — baked, deterministic.
export const DAILY_ORDER: string[] = [
  "persian-44",
  "persian-20",
  "arabic-68",
  "arabic-45",
  "persian-17",
  "arabic-49",
  "persian-68",
  "arabic-23",
  "persian-74",
  "persian-16",
  "persian-39",
  "persian-62",
  "arabic-22",
  "persian-67",
  "arabic-7",
  "persian-10",
  "arabic-57",
  "persian-66",
  "persian-23",
  "persian-79",
  "arabic-26",
  "arabic-67",
  "persian-15",
  "persian-26",
  "persian-1",
  "arabic-60",
  "persian-73",
  "arabic-14",
  "arabic-69",
  "arabic-55",
  "persian-63",
  "arabic-36",
  "arabic-61",
  "arabic-71",
  "persian-6",
  "arabic-2",
  "persian-11",
  "persian-76",
  "arabic-38",
  "arabic-16",
  "persian-60",
  "arabic-34",
  "arabic-25",
  "arabic-47",
  "arabic-24",
  "persian-24",
  "arabic-56",
  "arabic-62",
  "arabic-40",
  "arabic-1",
  "arabic-4",
  "persian-2",
  "persian-41",
  "persian-29",
  "persian-46",
  "persian-18",
  "arabic-33",
  "persian-4",
  "persian-14",
  "arabic-51",
  "persian-3",
  "arabic-11",
  "persian-13",
  "arabic-6",
  "arabic-65",
  "persian-51",
  "persian-65",
  "persian-81",
  "persian-64",
  "arabic-50",
  "persian-7",
  "persian-30",
  "arabic-9",
  "arabic-53",
  "persian-19",
  "arabic-13",
  "persian-25",
  "persian-82",
  "persian-45",
  "persian-71",
  "arabic-5",
  "persian-57",
  "arabic-52",
  "arabic-31",
  "persian-22",
  "persian-55",
  "persian-43",
  "arabic-8",
  "persian-40",
  "persian-48",
  "persian-36",
  "arabic-66",
  "persian-28",
  "persian-34",
  "arabic-17",
  "arabic-46",
  "persian-33",
  "persian-8",
  "arabic-3",
  "persian-72",
  "persian-5",
  "persian-32",
  "persian-54",
  "arabic-21",
  "persian-50",
  "arabic-12",
  "persian-59",
  "arabic-18",
  "arabic-59",
  "persian-35",
  "persian-12",
  "persian-56",
  "persian-52",
  "arabic-32",
  "persian-80",
  "arabic-43",
  "arabic-54",
  "persian-70",
  "persian-77",
  "arabic-44",
  "arabic-20",
  "arabic-48",
  "persian-27",
  "arabic-29",
  "arabic-15",
  "persian-61",
  "persian-78",
  "persian-53",
  "persian-31",
  "arabic-70",
  "arabic-41",
  "persian-75",
  "arabic-64",
  "persian-42",
  "persian-58",
  "arabic-63",
  "arabic-58",
  "persian-38",
  "persian-9",
  "arabic-28",
  "arabic-10",
  "persian-69",
  "persian-37",
  "arabic-19",
  "persian-21",
  "arabic-42",
]
